import React, {useEffect, useRef} from "react";
import {useStyles} from "../styles/EvenSpeakingStyle";
import {Box, Select, Popover, MenuItem, Button, FormControl, IconButton} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import clsx from "clsx";
import {withRouter} from "react-router-dom";
import {ReactComponent as ArrowDownIcon} from '../../../../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as RefreshDisableIcon} from '../../../../../../common/images/RefreshDisableIcon.svg';
import {ReactComponent as VolumeDisableIcon} from "../../../../../../common/images/VolumeDisableIcon.svg";
import {ReactComponent as DisabledAddTextBoxIcon} from "../../../../../../common/images/DisabledAddTextBoxIcon.svg";
import {ReactComponent as DisabledDeleteTextBoxIcon} from '../../../../../../common/images/DisabledDeleteTextBoxIcon.svg';
import {ReactComponent as TooltipClose} from '../../../../../../common/images/TooltipClose.svg';
import {ReactComponent as TooltipTipIcon} from '../../../../../../common/images/TooltipTipIcon.svg';
import Typography from "@material-ui/core/Typography";

function EvenSpeakingEditSelector(props) {
    const classes = useStyles();
    const {contents, evenStepSixStore} = props;
    const speakingBoxRef = useRef(null);
    const {popoverState} = evenStepSixStore;

    const handleClose = () => {
        evenStepSixStore.setPopoverState(false);
    }

    useEffect(() => {
        if (!!speakingBoxRef.current && !evenStepSixStore.speakingBoxRef) {
            evenStepSixStore.setPopoverState(true);
            evenStepSixStore.setSpeakingBoxRef(speakingBoxRef);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [speakingBoxRef]);

    const open = Boolean(speakingBoxRef);

    const id = open ? 'simple-popover' : undefined;

    const handleMouseUp = (key, boldStartIndex, boldEndIndex) => {
        const selection = window.getSelection();
        if (selection && selection.toString()) {
            const anchorNode = selection.anchorNode?.parentElement;
            const focusNode = selection.focusNode?.parentElement;
            const anchorNodeIndex = parseInt(anchorNode.getAttribute('index'));
            const focusNodeIndex = parseInt(focusNode.getAttribute('index'));
            let startIndex = anchorNodeIndex;
            let endIndex = focusNodeIndex + 1;
            if (anchorNodeIndex > focusNodeIndex) {
                startIndex = focusNodeIndex;
                endIndex = anchorNodeIndex + 1;
            }
            if (startIndex >= boldStartIndex && endIndex <= boldEndIndex) {
                if (startIndex > boldStartIndex && endIndex === boldEndIndex) {
                    endIndex = startIndex;
                    startIndex = boldStartIndex;
                } else if (endIndex < boldEndIndex && startIndex === boldStartIndex) {
                    startIndex = endIndex;
                    endIndex = boldEndIndex;
                } else {
                    startIndex = null;
                    endIndex = null;
                }


            }
            evenStepSixStore.setSpeakingContentTextIndex(startIndex, endIndex, key, contents);

            if (selection) {
                selection.removeAllRanges();
            }
        }
    }

    return (
        <>
            {contents?.map((content, key) => (
                <Box
                    key={key}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"flex-start"}
                >
                    <Box display={'flex'} alignItems={'center'} justifyContent={'flex-start'}
                         className={classes.PaddingBox}>
                        <Box sx={{padding: 0}}>
                            <FormControl className={classes.formControl}>
                                <Select
                                    value={content.voiceType}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    disabled={true}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className: classes.selectPopover
                                    }}
                                >
                                    <MenuItem value='Man'>성인남성</MenuItem>
                                    <MenuItem value='Woman'>성인여성</MenuItem>
                                    <MenuItem value='Child'>아이</MenuItem>
                                    <MenuItem value='Elderly'>노인</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box>
                            <IconButton style={{cursor: 'default'}} className={classes.iconButton}
                                        disableRipple>
                                <RefreshDisableIcon/>
                            </IconButton>
                        </Box>
                        <Box>
                            <Box className={clsx(classes.editTextListBox, classes.highlightTextBox)}

                                 aria-describedby={id} variant="contained" color="primary" ref={speakingBoxRef}>
                                <Typography onMouseUp={() => handleMouseUp(key, content.boldStartIndex, content.boldEndIndex)}>
                                    {content.text.split("").map((char, index) => {
                                        let background = 'transparent';
                                        if (index >= content.boldStartIndex && index < content.boldEndIndex) {
                                            background = 'rgba(242, 124, 87, 0.7)'
                                        }
                                        return <span key={index} index={index} style={{background}}>
                                            {char}
                                        </span>
                                    })}
                                </Typography>
                                <IconButton className={classes.volumeIconButton} disabled={true}>
                                    <VolumeDisableIcon/>
                                </IconButton>
                            </Box>
                        </Box>
                        <Box>
                            {key === 0 ?
                                <IconButton className={classes.iconButton}
                                            disabled={true}>
                                    <DisabledAddTextBoxIcon/>
                                </IconButton> :
                                key === contents.length - 1 &&
                                <IconButton className={classes.iconButton}
                                            disabled={true}>
                                    <DisabledDeleteTextBoxIcon/>
                                </IconButton>
                            }
                        </Box>
                    </Box>
                </Box>
            ))}
            <Popover
                id={id}
                open={popoverState}
                anchorEl={speakingBoxRef.current}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                className={classes.popoverTooltip}
            >
                <Box className={classes.tooltipTop}>
                    <TooltipTipIcon/>
                </Box>
                <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                    <Button disableRipple onClick={handleClose}>
                        <TooltipClose/>
                    </Button>
                </Box>
                <Typography className={classes.typography}>1. 볼드 지정을 원하는 글자를 드래그 해주세요.</Typography>
                <Typography className={classes.typography}>2. 드래그한 영역을 다시 드래그하면 선택이 해제됩니다.</Typography>
            </Popover>
        </>
    );
}

export default withRouter(inject('evenStepSixStore', 'contentStore')(observer(EvenSpeakingEditSelector)));
